export default [
	{
		path: '/invoices',
		name: 'invoice',
		meta: { requiresAuth: true },
		component: () => import('./views/index.vue')
	},
	{
		path: '/invoices/create',
		name: 'invoice-create',
		meta: { requiresAuth: true },
		component: () => import('./views/create.vue')
	},
	{
		path: '/invoices/:id',
		name: 'invoice-show',
		meta: { requiresAuth: true },
		component: () => import('./views/show.vue')
	}
]